import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";

export type DetailItem = {
  icon: LucideIcon;
  label: string;
  value: ReactNode;
};

export default function Details({ items }: { items: DetailItem[] }) {
  return (
    <div className="space-y-2">
      {items.map((item, index) => (
        <div key={index} className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 max-w-2/3">
            {item.icon && (
              <item.icon className="size-3.5 text-muted-foreground" />
            )}
            <span className="text-sm">{item.label}</span>
          </div>
          <span className="text-sm font-medium">{item.value}</span>
        </div>
      ))}
    </div>
  );
}
